import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { LoggerModule } from 'ngx-logger';
import { environment } from '@src/environments/environment';

/* App Root */
import { AppConfigModule } from './app-config.module';
import { AppComponent } from './app.component';

/* Routing Module */
import { AppRoutingModule } from './app-routing.module';

/* Shared Service */
import { CountryService } from "@shared/services/country.service";
import { I18nService } from '@shared/services/i18n.service';
import { IntercomService } from '@shared/services/intercom.service';
import { IntercomIntegrationService } from '@shared/services/intercomIntegration.service';
import { SoldoCookieService } from "@shared/services/soldo-cookie.service";
import { StartupService } from '@shared/services/startup.service';
import { SharedModule } from "@shared/shared.module";
import { RegistrationModule } from '@src/app/registration/registration.module';
import { AuthModule } from './auth/auth.module';
import { FileImportLoader } from './i18n/fileImportLoader.class';
import { StaticPagesModule } from './static-pages/static-pages.module';

// AoT requires an exported function for factories
export function TranslationLoaderFactory() {
    return new FileImportLoader();
}

export function startupServiceFactory(startupService: StartupService): () => Promise<any> {
    return () => startupService.load();
}

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [
        AppComponent
    ],
    imports: [
        LoggerModule.forRoot({
            serverLogLevel: environment.logLevel,
            level: environment.logLevel
        }),
        AppConfigModule,
        BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: TranslationLoaderFactory
            }
        }),
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        RegistrationModule,
        AuthModule,
        StaticPagesModule
    ], providers: [
        CountryService,
        StartupService,
        {
            provide: APP_INITIALIZER,
            useFactory: startupServiceFactory,
            deps: [StartupService],
            multi: true
        },
        CookieService,
        I18nService,
        SoldoCookieService,
        IntercomService,
        IntercomIntegrationService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
